import { useGtm } from '@gtm-support/vue-gtm'
import { TrackEventParams } from '@/types'

export function trackEvent(params: TrackEventParams): void {
  const gtm = useGtm()

  if (!gtm) {
    console.warn('GTM instance not found')
    return
  }

  gtm.trackEvent(params)
}
